export const CONFIGURATOR_SELECT = 'CONFIGURATOR_SELECT';
export const CONFIGURATOR_STORE_OPTION_NAME = 'CONFIGURATOR_STORE_OPTION_NAME';

export const selectConfiguratorOptions = (selectedCombinedConfiguratorKeys) => ({
    type: CONFIGURATOR_SELECT,
    payload: selectedCombinedConfiguratorKeys   
})